<template>
  <customize-form :schema="schema" ref="form" />
</template>

<script>
import { getCustomerInfo } from 'views/customer-mangement/detail/info/basic-profile/api'

export default {
  data() {
    return {
      schema: [
        {
          type: 'input',
          label: 'Duns Number',
          key: 'dunsNumber',
        },
        {
          type: 'input',
          label: 'CNPJ',
          key: 'cnpj',
        },
      ],
    }
  },
  methods: {
    async validate() {
      return this.$refs.form.getFormData()
    },
    async _getCustomerInfo() {
      try {
        const { base } = await getCustomerInfo(this.$route.params.customerId)
        this.schema.forEach((item, index) => {
          if (item.key === 'cnpj') {
            this.schema.splice(index, 1, { ...item, value: base.registeredNo })
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
  },
  created() {
    this._getCustomerInfo()
  },
}
</script>
